import { ConfirmDialog, useTheme } from '@h2oai/ui-kit';

export interface DeleteConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  itemName: string;
  isDirectory: boolean;
}

export const DeleteConfirmationModal = (props: DeleteConfirmationModalProps) => {
  const { isOpen, onClose, onConfirm, itemName, isDirectory } = props;
  const { palette } = useTheme();

  const getTitle = () => {
    return isDirectory ? 'Delete Directory' : 'Delete File';
  };

  const getContent = () => {
    if (isDirectory) {
      return (
        <div>
          <p>
            Are you sure you want to delete the directory <strong>&quot;{itemName}&quot;</strong>?
          </p>
          <p style={{ color: palette?.red500, marginTop: 8 }}>
            This action is permanent and cannot be undone. The directory and all of its contents will be deleted. All
            workspace members will immediately lose access to these items.
          </p>
        </div>
      );
    } else {
      return (
        <div>
          <p>
            Are you sure you want to delete <strong>&quot;{itemName}&quot;</strong>?
          </p>
          <p style={{ color: palette?.red500, marginTop: 8 }}>
            This action is permanent and cannot be undone. All workspace members will immediately lose access to this
            file.
          </p>
        </div>
      );
    }
  };

  return (
    <ConfirmDialog
      hidden={!isOpen}
      title={getTitle()}
      content={getContent()}
      onConfirm={onConfirm}
      onDismiss={onClose}
      confirmationButtonText="Delete"
    />
  );
};
